import { component } from "picoapp";

export const productTracker = component((node: HTMLElement) => {
  const viewedProductDetailsData = {
    "product category": node.dataset.mtrProductCategory,
    "product id": node.dataset.mtrProductId,
    "product name": node.dataset.mtrProductName,
    "product price": node.dataset.mtrProductPrice,
    "variant id": node.dataset.mtrVariantId,
    "variant name": node.dataset.mtrVariantName,
    "variant price": node.dataset.mtrVariantPrice,
    "variant sku": node.dataset.mtrVariantSku,
    "bundle name": node.dataset.mtrBundleName,
    source: window.location.href,
    market: node.dataset.mtrMarket,
  };

  const viewedProductdata = {
    Name: node.dataset.mtrProductName,
    ProductID: node.dataset.mtrProductId,
    Categories: node.dataset.mtrProductCategory,
    ImageURL: node.dataset.mtrProductImageUrl,
    URL: node.dataset.mtrProductUrl,
    Brand: node.dataset.mtrProductBrand,
    Price: node.dataset.mtrProductPrice,
    CompareAtPrice: node.dataset.mtrProductCompareAtPrice,
    Market: node.dataset.mtrMarket,
    Currency: node.dataset.mtrCurrency,
  };

  window.maestro.fireTrackEvent("viewProductDetails", viewedProductDetailsData);
  window.maestro.fireTrackEvent("viewedProduct", viewedProductdata);
});
